export const CONTACT_US_ICONS: Record<string, string> = {
    'Address': 'icon-tfw-location-filled',
};

export const commonInputStyleProps = {
    borderRadius: '4px',
    border: '1px solid',
    borderColor: 'common.borderGrey',
    _active: {
        borderColor: 'common.borderGrey',
    },
    _hover: {
        borderColor: 'button.blue',
    },
    bg: 'common.white',
}

export const clearButtonProps = {
    w: { base: '100%', md: '50%' },
    variant: 'outline',
    bg: 'background.main',
    color: 'brand.lightTertiary',
    borderColor: 'brand.lightTertiary',
    cursor: 'pointer',
    _hover: {
        bg: 'brand.tertiary',
        color: 'brand.secondary',
        borderColor: 'brand.tertiary',
    },
    _focus: {
        borderRadius: '5px solid',
    }
};

export const selectTagProps = {
    required: true,
    h: '36px',
    pl: '32px',
    borderRadius: '0 4px 4px 0',
    border: 'none',
    _focus: {
        boxShadow: 'none',
        border: 'none',
    },
    _active: {
        borderColor: 'common.borderGrey',
        outline: 'none',
    },
}